import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/global.css';
import './styles/store.css';

// SPA servido na RAIZ do host cardapio.vittogestao.com.br; o slug é uma rota
// (/:slug), não um subdiretório. O servidor deve fazer fallback de todas as
// rotas para index.html (ver README).
const el = document.getElementById('root');
if (!el) throw new Error('Elemento #root não encontrado.');

createRoot(el).render(
  <StrictMode>
    {/* QA CRÍTICO — defesa em profundidade: um erro fatal de render em qualquer lugar da loja (ex.:
        item de sacola corrompido que escapou da validação de useBag) não pode derrubar a página INTEIRA
        em tela branca sem recuperação. Ponto de montagem mais alto de propósito — cobre TUDO,
        inclusive o roteamento. */}
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
